// Isolated in its own module because import.meta.url (needed for webpack 5
// to bundle the worker as a separate chunk) can't be parsed by CRA's Jest
// transform — Jest swaps this module out for a mock via package.json's
// moduleNameMapper instead of trying to parse the real one. Only ever
// called from App.js's startAutoPlan.
export const createSearchWorker = () => new Worker(new URL('./searchWorker.js', import.meta.url));
